import { InputSelectControlContent } from '../InputSelectControlContent'

/**
 * Input select control content without selected items inside.
 * Can be used for multi item select.
 */
function InputMultiSelectControlContent(props) {
  return <InputSelectControlContent {...props} ValueItem={null} />
}

export default InputMultiSelectControlContent
